// extracted by mini-css-extract-plugin
export default {"exhibition":"exhibition_n3o89","information":"information_N91tH"};